import React, { useState, useEffect } from "react";
import { useError } from "../hooks";

export default function Error() {
  const [hidden, setHidden] = useState(true);
  const { error, getRenderedError } = useError();

  const clickListener = () => setHidden(true);

  useEffect(() => {
    if (error) {
      setHidden(false);
      window.addEventListener("click", clickListener);
    } else {
      setHidden(true);
      window.removeEventListener("click", clickListener);
    }
  }, [error]);

  return (
    <div id="error" className={hidden ? "hidden" : ""}>
      <div className="error__body">{getRenderedError()}</div>
    </div>
  );
}
